import React, { useEffect } from "react";
import { leavesService } from "../../../../api/services/leavesService";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValue {
  setAllLeaveTypesData: (data: any) => void;
  setAllLeaveEnhanceTypesData: (data: any) => void;
  setLeavesEligibility: (data: any) => void;
}
const DTOApplyLeaveModal = ({
  setAllLeaveTypesData,
  setLeavesEligibility,
  setAllLeaveEnhanceTypesData
}: PropsValue) => {
  const selector = useAppSelector((state) => state.authSlice);
  const storeLeaveEligibility = useAppSelector(
    (state) => state.leaveEligibilitySlice.leaveEligibility
  );

  async function getAllLeaveTypes(companyId: number, empId: number) {
    const respose: any = await leavesService.getCompanyLeaveTypes(companyId, empId);
    if (respose) {
      setAllLeaveTypesData(respose?.data);
    }
    setLeavesEligibility(storeLeaveEligibility);
  }

  async function getCompanyOtherPaymentTypes(companyId: number) {
    const respose: any = await leavesService.getCompanyOtherPaymentTypes(companyId);
    if (respose) {
      setAllLeaveEnhanceTypesData(respose?.data);
    }
  }

  useEffect(() => {
    if (selector) {
      getAllLeaveTypes(selector.company_id, selector.emp_id);
      getCompanyOtherPaymentTypes(selector.company_id);
    }
  }, []);

  return <></>;
};

export default DTOApplyLeaveModal;
